import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UpdateAttendanceLogEntryParameters, updateAttendanceLogEntry } from 'src/api/attendanceAPI';
import ApiError from 'src/api/errorHandling/ApiError';
import AttendanceLogEntry from 'src/models/AttendanceLogEntry';

export default function useUpdateAttendanceLogEntry() {
  const queryClient = useQueryClient();

  return useMutation<AttendanceLogEntry, ApiError, UpdateAttendanceLogEntryParameters>(async parameters => {
    const result = await updateAttendanceLogEntry(parameters);
    queryClient.invalidateQueries(['attendanceLog']);
    return result;
  });
}
